import {html, LitElement,} from "../../admin/script/libs/lit.dist.js";
import style from './pk-show-password.css.js';
import './pk-show-password.scss';

class PkShowPassword extends LitElement {

    static styles = [style];

    static properties = {
        show: {type: Boolean},
        inputElement: {state: true},
    };

    findInputElement() {
        const slot = this.renderRoot.querySelector('slot');
        const children = slot?.assignedElements()
        for (let el of children) {
            if (el.type === 'password') {
                return el;
            }
        }
        return undefined;
    }

    updateInputElement() {
        this.inputElement = this.findInputElement();
    }

    firstUpdated(t) {
        super.firstUpdated(t);
        this.updateInputElement();
    }

    get isShowing() {
        return this.inputElement?.type !== 'password';
    }

    onClickShowButton() {
        if (this.inputElement) {
            this.inputElement.type = this.isShowing ? 'password' : 'text';
            this.requestUpdate();
        }
    }

    render() {
        return html`
            <slot @slotchange="${this.updateInputElement.bind(this)}"></slot>
            ${this.inputElement ? html`
                <button 
                    type="button" 
                    class="${this.isShowing ? 'hide-button' : 'show-button'}"
                    @click="${this.onClickShowButton.bind(this)}" 
                    aria-hidden="true"
                    tabindex="-1"
                ></button>
            ` : null}
        `;
    }
}

window.customElements.define('pk-show-password', PkShowPassword);
